import type { TranslationKey } from '@/i18n';

export const onboardingStrings = {
  modeTitle: 'onboarding.mode.title',
  modeDescription: 'onboarding.mode.description',
  skipForNow: 'onboarding.mode.skipForNow',
  continue: 'common.continue',
  add: 'common.add',
  profileTitle: 'onboarding.profile.title',
  profileDescription: 'onboarding.profile.description',
  yourName: 'onboarding.profile.yourName',
  hereFor: 'onboarding.profile.hereFor',
  chooseReasonBelow: 'onboarding.profile.chooseReasonBelow',
  displayName: 'onboarding.profile.displayName',
  displayNamePlaceholder: 'onboarding.profile.displayNamePlaceholder',
  randomName: 'onboarding.profile.randomName',
  headline: 'onboarding.profile.headline',
  headlinePlaceholder: 'onboarding.profile.headlinePlaceholder',
  dateOfBirth: 'onboarding.profile.dateOfBirth',
  dateOfBirthPlaceholder: 'onboarding.profile.dateOfBirthPlaceholder',
  publicAgeBand: 'onboarding.profile.publicAgeBand',
  dateOfBirthPrivate: 'onboarding.profile.dateOfBirthPrivate',
  friendshipGoal: 'onboarding.profile.friendshipGoal',
  friendshipGoalShort: 'onboarding.profile.friendshipGoalShort',
  chooseOne: 'onboarding.profile.chooseOne',
  chooseReason: 'onboarding.profile.chooseReason',
  customReasonPlaceholder: 'onboarding.profile.customReasonPlaceholder',
  closeGoalOptions: 'onboarding.profile.closeGoalOptions',
  goalSelectionA11y: 'onboarding.profile.goalSelectionA11y',
  headlineRequired: 'onboarding.profile.headlineRequired',
  headlineTooLong: 'onboarding.profile.headlineTooLong',
  goalRequired: 'onboarding.profile.goalRequired',
  minimumAge: 'onboarding.profile.minimumAge',
  customGoalRequired: 'onboarding.profile.customGoalRequired',
  customGoalLimit: 'onboarding.profile.customGoalLimit',
  customGoalDuplicate: 'onboarding.profile.customGoalDuplicate',
} as const satisfies Record<string, TranslationKey>;

/**
 * Onboarding intent and public-profile setup. Friendship goals are low-pressure
 * social intentions, not dating preferences. Date of birth remains private;
 * only the calculated age band is public. Keep opncue lowercase.
 */
